export const PASSWORD_REQUIREMENT_MESSAGE =
  "Use at least 8 characters with at least one number and one symbol.";

export function passwordPolicyError(password: string): string | null {
  if (password.length < 8) {
    return PASSWORD_REQUIREMENT_MESSAGE;
  }
  if (!/\d/.test(password)) {
    return PASSWORD_REQUIREMENT_MESSAGE;
  }
  if (!/[^A-Za-z0-9\s]/.test(password)) {
    return PASSWORD_REQUIREMENT_MESSAGE;
  }
  return null;
}
